module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-top-stone-path-background.2b900b3e.png";